/**
 * Display / normalize a stored client IP for the UI.
 * Proxies sometimes persist `ip:port` — never show the port.
 */
export function displayClientIp(value: string | null | undefined): string {
  if (value == null) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";

  // IPv4:port
  const ipv4Port = /^(\d{1,3}(?:\.\d{1,3}){3}):\d+$/;
  const ipv4Match = trimmed.match(ipv4Port);
  if (ipv4Match) return ipv4Match[1];

  // [IPv6]:port
  const ipv6Port = /^\[([^\]]+)\]:\d+$/;
  const ipv6Match = trimmed.match(ipv6Port);
  if (ipv6Match) return ipv6Match[1];

  return trimmed;
}
